import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import { Button, Grid } from "@mui/material";
import { getLogin } from "redux/actions/UserLogin";
import { updateProfile } from "redux/actions/UserProfile";
import { getRegistration } from "redux/actions/UserRegistration";

function Timer(props) {
  const {profile,value} = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [timerValue, setTimerValue] = useState(60);
  const [isResendActive, setIsResendActive] = useState(false); 
  const signupDetails = JSON.parse(localStorage.getItem("signUpDetails"));
  const loginDetails = JSON.parse(localStorage.getItem("loginDetails"));
  const mobile = localStorage.getItem("mobile");
  const code = localStorage.getItem("code");
  const credentialsDetails = props?.pageType ? signupDetails : loginDetails;
  useEffect(() => {
    callIntervalFunction(); 
  }, []);

  const callIntervalFunction = () => {
    const interval = setInterval(() => {
      setTimerValue((prevTimerValue) => {
        if (prevTimerValue === 1) {
          props?.setAutoFocusOtp(false);
          setIsResendActive(true); 
          clearInterval(interval);
        }
        return prevTimerValue - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }
 
  const onResend = () => {
    if(profile){
     let profileUpdateDetails;
          if(Number(value) && value.length === 10){
         profileUpdateDetails = {
          mobile: value,
          countryCode: credentialsDetails?.code,
         }}
         else{
          profileUpdateDetails = {
            email: value
           }}
      dispatch(updateProfile(profileUpdateDetails,"Resend"))
      }
      else if(props?.pageType === "signupOtp"){
        const signUpPayload ={
          userDetails: {
            platform: "CustomerApp",
            mobile: credentialsDetails.mobile,
            firstName:credentialsDetails.firstname,
            lastName:credentialsDetails.lastname,
            email: credentialsDetails.email,
           gender:credentialsDetails.gender,
           countryCode: credentialsDetails.code,
          },
          actionType: "resendOtp"
        } 
      dispatch(getRegistration(signUpPayload, navigate));
    }
      else{
        const loginPayload = {
        userDetails : {
          platform: "CustomerApp",
          mobileOrEmail:credentialsDetails?.mobile,
          countryCode: credentialsDetails?.code,
        },
        actionType : "login"
      }
        dispatch(getLogin(loginPayload, navigate,props?.setOnOtp));
      } 
      setIsResendActive(false);
      setTimerValue(60)
      callIntervalFunction();
      props?.onResend()
      props?.setAutoFocusOtp(true);
  };

  return (
    <div>
      <Grid container direction="row" alignItems="center" spacing={2}>
        <Grid item>
          {!isResendActive && (
            <CountdownCircleTimer
              isPlaying
              size={50}
              strokeWidth={5}
              isGrowing="true"
              rotation="clockwise"
              duration={60}
              colors={["#0f538D"]}
            >
              {({ remainingTime }) => (
                <div className="colorPrimary">
                  {remainingTime} <span className="font7">Sec</span>
                </div>
              )}
            </CountdownCircleTimer>
          )}
        </Grid>

        <Grid item>
          <Button
            className={`textDecUnderlined otpResend
              ${isResendActive} ? "colorPrimary" : "colorGrey"
            `}
            disabled={!isResendActive}
            onClick={() => onResend()}
          >
            Resend
          </Button>
        </Grid>
      </Grid>
    </div>
  );
}

export default Timer;
